import React, { FunctionComponent } from 'react';
import { Table, TableRow, TableBody, TableCell, TableHead, Typography } from '@mui/material';
import { StringFormatter } from '../../../../utils';
import { ISummaryReport } from '../../../../interfaces/calculator.interface';
import { useStyles, useTableCellStyles } from './TotalSavings.styles';


interface IProps {
  report: ISummaryReport;
}

const TotalSavingsByTimeframe: FunctionComponent<IProps> = ({ report }) => {
  const classes = useStyles();
  const tableClasses = useTableCellStyles();
  const tableRows = [
    {
      titleClass: classes.columnTitle,
      title: 'Short-Term (≤1 year)',
      firstAmountClass: classes.sectionAmount,
      firstAmount: StringFormatter.roundedMoney(report?.totalSavingsByShortTerm?.toString() || '0'),
      secondAmountClass: classes.sectionAmount,
      secondAmount: StringFormatter.interventionPercentage(report?.totalSavingsShortTermPercentage?.toString() || '0'),
      visible: true,
    },
    {
      titleClass: classes.sectionTitle,
      title: 'Long-Term (>1 year)',
      firstAmountClass: classes.sectionAmount,
      firstAmount: StringFormatter.roundedMoney(report?.totalSavingsByLongTerm?.toString() || '0'),
      secondAmountClass: classes.sectionAmount,
      secondAmount: StringFormatter.interventionPercentage(
        report?.totalSavingsLongTermPercentage?.toString() || '0'
      ),
      visible: true,
    },
    {
      titleClass: classes.subsectionTitle,
      title: 'Total',
      firstAmountClass: classes.subsectionAmount,
      firstAmount: StringFormatter.roundedMoney(
        report?.totalSavingsByTimeframe?.toString() || '0'
      ),
      secondAmountClass: classes.subsectionAmount,
      secondAmount: StringFormatter.interventionPercentage(
        report?.totalSavingsTimeframePercentage?.toString() || '0'
      ),
      visible: true,
    },
  ];
  return (
    <div>
      <Typography variant="h2" className={classes.contentTitle}>Total Savings by Timeframe</Typography>
      <Table className={classes.tableContainer}>
        <TableHead>
          <TableCell className={classes.tableHead} align="left">
            Timeframe
          </TableCell>
          <TableCell className={classes.tableHead} align="center">
            $
          </TableCell>
          <TableCell className={classes.tableHead} align="center">
            %
          </TableCell>
        </TableHead>
        <TableBody>
          {tableRows.map((row, idx) => (
            row.visible ?
              <TableRow key={idx}>
                <TableCell component="th" scope="row" className={tableClasses.cell}>
                  {row.title}
                </TableCell>
                <TableCell className={`${row.firstAmountClass} ${tableClasses.cell}`} align="right">
                  {row.firstAmount}
                </TableCell>
                <TableCell className={`${row.secondAmountClass} ${tableClasses.cell}`} align="right">
                  {row.secondAmount}
                </TableCell>
              </TableRow>
              : <></>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default TotalSavingsByTimeframe;
